import { useNavigate } from "react-router-dom";
import * as React from 'react';
import Navbar from "../components/navbar";
import { Box, FormGroup, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import Button from "@mui/material/Button";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useState } from "react";
import { auth } from "../firebase-config";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase-config";
import { useEffect } from "react";
import { collection, query, where, getDocs, doc, updateDoc, getDoc, orderBy } from "firebase/firestore";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

const Home = () => {

    const navigate = useNavigate();
    const [isVoting, setIsVoting] = useState(false);
    const [hasVoted, setHasVoted] = useState(localStorage.getItem("voted"));
    const [songs, setSongs] = useState([]);
    const [selectedSongs, setSelectedSongs] = useState([]);
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const { register, handleSubmit, watch, control } = useForm();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClose = () => {
       setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
     };

    const handleCheckboxChange = (name) => {

        const newSongList = songs.map((song) => {
            if (song.name === name) {
                console.log("value changed", name, "to: ", !song.value);
                return {id:song.id, name: song.name, lokalita: song.lokalita, typ:song.typ, value: !song.value};
            } else {
                // The rest haven't changed
                return song;
            }
        });
        setSongs(newSongList);
    };

    useEffect(() => {
        getData();
        
    }, []);

    async function getData() {

        const docRef = doc(db, "hlasovanie", "1");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setIsVoting(docSnap.data().spustene);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
          }
        const q = query(collection(db, "piesne"), orderBy("Názov"));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
            // songs.push({name: doc.data().Názov, lokalita: doc.data().Lokalita, value: false});
            setSongs( songs_ => [...songs_, {id: doc.id, name: doc.data().Názov, lokalita: doc.data().Lokalita, typ: doc.data().Typ, value: false}]);
        });
        console.log(songs);
      }

    const handleVoting = () => {
        console.log("Selected songs:");
        const songsToUpdate = [];
        songs.forEach((song) => song.value == true ? songsToUpdate.push(song) : null)
        console.log(songsToUpdate);

        songsToUpdate.forEach((song => {
            updateSongs(song);
            
        }));
        setHasVoted(true);
        setOpen(false);
        setSnackbarOpen(true);
        localStorage.setItem("voted", true);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setSnackbarOpen(false);
      };

    async function updateSongs(song){

        const docRef = doc(db, "piesne", song.id);
        const docSnap = await getDoc(docRef);   
        const aktualneHlasy = docSnap.data().AktualneHlasy;
        const celkoveHlasy = docSnap.data().CelkoveHlasy;

        const songRef = doc(db, "piesne", song.id);

            // Set the "capital" field of the city 'DC'
            await updateDoc(songRef, {
                AktualneHlasy: aktualneHlasy+1,
                CelkoveHlasy: celkoveHlasy+1
            });

    }

    if(isVoting) return (
        // <Box sx={{justifyContent: 'center', margin: 2, alignContent: 'center'}}>
        <Stack 
            justifyContent="center"
            alignItems="left"
            spacing = {2}
            sx={{ margin: 2 }}
            >
            <Typography variant="h5">Hlasovanie je spustené!</Typography>

            <Typography variant="body">Vyberte pesničky, ktoré si prajete dať zahrať a potvrďte svoj výber tlačidlom. Po potvrdení
            výberu už nie je možné hlasovať znova.</Typography>
            
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                <Typography>Goralské</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FormGroup>
                        {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Goralská" && 
                                
                                <FormControlLabel control={<Checkbox />} label={song.name} value={song.name} onChange={() => {handleCheckboxChange(song.name)}}/>
                                }

                            </div>
                        ))}
                    </FormGroup>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography>Rusínske</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Rusínska" && 
                                
                                <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />
                                }

                            </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Východniarske</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Východ" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>České</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Česká" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Západoslovenské</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Západ" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Telgárt</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Telgárt" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Cigánske</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Cigánska" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Detvianske</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Detva" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Považské</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.lokalita === "Považie" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>

                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Vojenské</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.typ == "vojenská" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Poľovnícke</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                            <div>
                                {song.typ == "poľovnícka" && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                             </div>
                        ))}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                <Typography>Ostatné</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {songs.map((song, index) => (
                    <div>
                        {!song.Typ && !song.lokalita && <FormControlLabel control={<Checkbox />} label={song.name} onChange={() => {handleCheckboxChange(song.name)}} />}
                        </div>
                ))}
                </AccordionDetails>
            </Accordion>


            <Button
                variant="contained"
                color="primary"
                className="form-input"
                size="large"
                style={{ margin: 16 }}
                onClick={handleOpen}
                disabled={hasVoted}
            >
                Hlasovať
            </Button>


            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Ste si istý, že chcete hlasovať?</DialogTitle>
                <DialogContent>
                    <Typography>Po odoslaní formulára už nebude možné hlasovať znova.</Typography>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose}>Zrušiť</Button>
                <Button onClick={handleVoting} variant="contained">Hlasovať</Button>
                </DialogActions>
            </Dialog>

            <Snackbar 
                open={snackbarOpen} 
                autoHideDuration={3000} 
                onClose={handleSnackbarClose}
                anchorOrigin={{vertical: "top", horizontal: "center"}}>

                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                Hlasovanie bolo úspešné!
                </Alert>
            </Snackbar>
                
            
            </Stack>
        // </Box>
    )

    else return(
        <Stack height="100vh" direction="column" justifyContent="center" spacing={3} sx={{height:'100%', alignItems: 'center', justifyContent: 'center'}}>
            <Box sx={{height: '35vh'}}></Box>
            <Typography variant="h6">Hlasovanie momentálne nie je spustené!</Typography>
            
        </Stack>
    )
}
export default Home;